<div class="grid grid-cols-5 gap-2 pb-2">
  <div class="bg-stat-card shadow-sm hover:border-slate-300 hover:shadow-md transition-all">
    <div class="p-2">
      <p class="mb-2 text-gray-400 text-sm font-semibold">
        Pending Loads
      </p>
      <div class="flex">
        <p class="text-gray-600 leading-normal text-2xl font-bold">
          {{ stats?.pendingLoads.value }}
        </p>
      </div>
    </div>
  </div>

  <div class="bg-stat-card shadow-sm hover:border-slate-300 hover:shadow-md transition-all">
    <div class="p-2">
      <p class="mb-2 text-gray-400 text-sm font-semibold">
        In Progress Loads
      </p>
      <div class="flex">
        <p class="text-gray-600 leading-normal text-2xl font-bold">
          {{ stats?.inProgressLoads.value }}
        </p>
      </div>
    </div>
  </div>

  <div class="bg-stat-card shadow-sm hover:border-slate-300 hover:shadow-md transition-all">
    <div class="p-2">
      <p class="mb-2 text-gray-400 text-sm font-semibold">
        Loads Verified By OCR (7 days)
      </p>
      <div class="flex">
        <p class="text-gray-600 leading-normal text-2xl font-bold">
          {{ stats?.ocrVerifiedLoads.value }}
        </p>
      </div>
    </div>
  </div>

  <div class="bg-stat-card shadow-sm hover:border-slate-300 hover:shadow-md transition-all">
    <div class="p-2">
      <p class="mb-2 text-gray-400 text-sm font-semibold">
        Completed Loads (7 days)
      </p>
      <div class="flex">
        <p class="text-gray-600 leading-normal text-2xl font-bold">
          {{ stats?.completedLoads.value }}
          <mat-icon>trending_{{ stats?.completedLoads.trend }}</mat-icon>
        </p>
        <div [ngSwitch]="stats?.completedLoads.trend">
          <div *ngSwitchCase="'up'" class="text-green-500">+{{ stats?.completedLoads.difference | number }}</div>
          <div *ngSwitchCase="'flat'" class="text-gray-600">{{ stats?.completedLoads.difference | number }}</div>
          <div *ngSwitchCase="'down'" class="text-red-500">{{ stats?.completedLoads.difference | number }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="bg-stat-card shadow-sm hover:border-slate-300 hover:shadow-md transition-all">
    <div class="p-2">
      <p class="mb-2 text-gray-400 text-sm font-semibold">
        Revenue (7 days)
      </p>
      <div class="flex">
        <p class="text-gray-600 leading-normal text-2xl font-bold">
          {{ stats?.revenue.value | currencyInPennies }}
          <mat-icon>trending_{{ stats?.revenue.trend }}</mat-icon>
        </p>
        <div [ngSwitch]="stats?.revenue.trend">
          <div *ngSwitchCase="'up'" class="text-green-500">+{{ stats?.revenue.difference | currencyInPennies }}</div>
          <div *ngSwitchCase="'flat'" class="text-gray-600">{{ stats?.revenue.difference | currencyInPennies }}</div>
          <div *ngSwitchCase="'down'" class="text-red-500">{{ stats?.revenue.difference | currencyInPennies }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
